<div>
    <div fxLayout="row wrap" fxLayoutAlign="center" fxFlex="100">
      <div fxLayoutAlign="center"  class="ps-form-container">
        <iframe class="ps-iframe" width="100%" height="100%" [src]="reportUrl" [frameBorder]="0"></iframe>
      </div>
    </div>
</div>
